import { makeStyles, tokens } from '@fluentui/react-components';

export const useSummaryCardBarStyles = makeStyles({
  row: {
    display: 'grid',
    // Column count is set dynamically via the --summary-col-count CSS custom
    // property so the media query below can still override it on small screens.
    gridTemplateColumns: 'repeat(var(--summary-col-count, 4), 1fr)',
    gap: tokens.spacingHorizontalL,
    marginBottom: tokens.spacingVerticalXXL,
    '@media (max-width: 600px)': {
      gridTemplateColumns: '1fr',
    },
  },
  card: {
    padding: `${tokens.spacingVerticalL} ${tokens.spacingHorizontalXL}`,
    // Suppress Fluent Card's built-in focus/focus-within outlines entirely.
    // We manage our own active-state indicator via `cardActive` styling.
    '&[data-fui-focus-within]:focus-within::after': {
      content: 'none',
    },
    '&[data-fui-focus-visible]::after': {
      content: 'none',
    },
    ':focus': {
      outlineStyle: 'none',
    },
    ':focus-visible': {
      outlineStyle: 'none',
    },
  },
  cardClickable: {
    cursor: 'pointer',
    transition: 'box-shadow 0.1s ease, opacity 0.1s ease',
    ':hover': {
      boxShadow: tokens.shadow8,
    },
  },
  cardActive: {
    boxShadow: tokens.shadow8,
  },
  label: {
    display: 'block',
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase300,
    lineHeight: tokens.lineHeightBase300,
    color: tokens.colorNeutralForeground2,
    marginBottom: tokens.spacingVerticalXS,
  },
  value: {
    fontSize: tokens.fontSizeBase600,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase600,
    color: tokens.colorNeutralForeground1,
  },
});
